import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';
import useTestId from '@ori/testid-generator';
import type { PropsWithChildren, FC } from 'react';

import { CSS_DESKTOP_HEIGHT, CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT } from '../constants';
import { useAppConfig, useTopAreaBanner } from '../context';
import type { AppConfig } from '../models';
import { getMobileCssHeightVariable } from '../utils/getMobileCssVariable';

interface TopAreaReservedSpaceBlockProps extends Pick<AppConfig, 'showSearchOnScroll'> {
  isTopBannerVisible: boolean;
}

const TopAreaReservedSpaceBlock = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})<TopAreaReservedSpaceBlockProps>(({ isTopBannerVisible, showSearchOnScroll, theme }) => ({
  minHeight: getMobileCssHeightVariable({ isTopBannerVisible, showSearchOnScroll }),
  [theme.breakpoints.up('md')]: {
    minHeight: isTopBannerVisible ? CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT : CSS_DESKTOP_HEIGHT,
  },
}));

export const TopAreaBlock: FC<PropsWithChildren> = ({ children }) => {
  const { getTestId } = useTestId();
  const { visible: isTopBannerVisible } = useTopAreaBanner();
  const { showSearchOnScroll } = useAppConfig();

  return (
    <TopAreaReservedSpaceBlock
      data-testid={getTestId('root-wrapper')}
      id="top-area"
      isTopBannerVisible={isTopBannerVisible}
      showSearchOnScroll={showSearchOnScroll}
    >
      {children}
    </TopAreaReservedSpaceBlock>
  );
};
